export default __webpack_public_path__ + "static/media/shield-icon.7cfc6ab4.svg";